// Autogenerated by publish_packages.clj
const version = 'v0.20.16';

export default version;
